(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["holiday-closure"] && !Shopify.designMode) return;
  try {
    if (!sessionStorage.getItem("holiday_closure")) {
        const dialog = document.getElementById("holiday_closure_dialog");

        if (!dialog)
            return;

        dialog.showModal();
    }
    sessionStorage.setItem("holiday_closure", "true");
  } catch(e) { console.error(e); }
})();

})();
